const initialState = { 
    appInfo : {},
    appList : [],
    featuredAppList : [],
};

export const AppConstant = {
    GET_APP_INFO: 'GET_APP_INFO',
    GET_RELEASE_NOTES: 'GET_RELEASE_NOTES',
    GET_MANUAL: 'GET_MANUAL',
    GET_APP_LIST: 'GET_APP_LIST',
    GET_FEATURED_APP_LIST: 'GET_FEATURED_APP_LIST'
};

export const AppReducer = (state = initialState, action) => {
    switch (action.type) {
        case AppConstant.GET_APP_INFO:
            return {...state, appInfo : action.data}

        case AppConstant.GET_RELEASE_NOTES:
            return { ...state, releasenotes: action.data }

        case AppConstant.GET_MANUAL:
            return { ...state, manual: action.data }

        case AppConstant.GET_APP_LIST:
            return { ...state, appList: action.data }

        case AppConstant.GET_FEATURED_APP_LIST:
            return { ...state, featuredAppList: action.data }

        default:
            return state;
    }
}
